/**
 * Carousel Progress Bar Handler - DEBUG VERSION
 * This version includes console logging to help identify the sync issue
 */

(function() {
  'use strict';

  // Function to update progress bar
  function updateProgressBar(cardGallery, slideIndex, slideCount, instant = false) {
    const progressBar = cardGallery.querySelector('.carousel-progress-fill');
    if (!progressBar || slideCount <= 1) return;

    // Log for debugging
    console.log('📊 Update Progress:', {
      slideIndex: slideIndex,
      slideCount: slideCount,
      instant: instant
    });

    // Ensure slideIndex is within valid range
    slideIndex = Math.max(0, Math.min(slideIndex, slideCount - 1));

    // Calculate the width of one segment
    const segmentWidth = 100 / slideCount;
    
    // Calculate the left position based on current slide
    const leftPosition = slideIndex * segmentWidth;
    
    console.log('📐 Calculations:', {
      segmentWidth: segmentWidth + '%',
      leftPosition: leftPosition + '%',
      transform: `translateX(${leftPosition * (100 / segmentWidth)}%)`
    });
    
    // Update the progress bar
    if (instant) {
      progressBar.style.transition = 'none';
    } else {
      progressBar.style.transition = 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)';
    }
    
    progressBar.style.width = segmentWidth + '%';
    progressBar.style.transform = `translateX(${leftPosition * (100 / segmentWidth)}%)`;
    
    // Force a reflow to ensure transition is applied
    if (instant) {
      void progressBar.offsetWidth;
      progressBar.style.transition = 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)';
    }
  }

  // Function to initialize a card gallery
  function initializeCardGallery(cardGallery) {
    const slideshow = cardGallery.querySelector('slideshow-component');
    if (!slideshow) {
      console.warn('❌ No slideshow found in card-gallery');
      return;
    }

    const slideCountAttr = cardGallery.getAttribute('data-slide-count');
    const slideCount = parseInt(slideCountAttr, 10) || 0;
    
    console.log('🎬 Initializing Gallery:', {
      slideCountFromAttr: slideCount
    });
    
    if (slideCount <= 1) {
      console.log('⏭️ Skipping: Only 1 or 0 slides');
      return;
    }

    // Get actual visible slides count from slideshow
    const allSlides = slideshow.querySelectorAll('slideshow-slide');
    const visibleSlides = slideshow.querySelectorAll('slideshow-slide:not([hidden])');
    
    console.log('🔍 Slide Analysis:', {
      totalSlides: allSlides.length,
      visibleSlides: visibleSlides.length,
      dataSlideCount: slideCount
    });
    
    // Use visible slides count
    const finalSlideCount = visibleSlides.length > 0 ? visibleSlides.length : slideCount;
    
    console.log('✅ Using slide count:', finalSlideCount);

    // Initialize progress bar on first load
    requestAnimationFrame(() => {
      const initialIndex = slideshow.current || 0;
      console.log('🎯 Initial slide index:', initialIndex);
      updateProgressBar(cardGallery, initialIndex, finalSlideCount, true);
    });

    // Track if we're currently dragging
    let isDragging = false;
    let dragUpdateTimeout;
    let lastKnownIndex = 0;

    // Listen for slideshow select events (fired when slide changes)
    slideshow.addEventListener('slideshow:select', function(event) {
      const slideIndex = event.detail.index;
      const isInstant = event.detail.trigger === 'select' && !event.detail.userInitiated;
      
      console.log('🎯 Slide Select Event:', {
        index: slideIndex,
        previousIndex: event.detail.previousIndex,
        trigger: event.detail.trigger,
        userInitiated: event.detail.userInitiated,
        slideId: event.detail.id
      });
      
      // Clear any pending drag updates
      clearTimeout(dragUpdateTimeout);
      
      // Update last known index
      lastKnownIndex = slideIndex;
      
      updateProgressBar(cardGallery, slideIndex, finalSlideCount, isInstant);
    });

    // Listen for dragging state
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'dragging') {
          const wasDragging = isDragging;
          isDragging = slideshow.hasAttribute('dragging');
          
          console.log('🖱️ Drag state changed:', isDragging ? 'Started' : 'Ended');
          
          // When drag ends, ensure we're at the correct position
          if (wasDragging && !isDragging) {
            setTimeout(function() {
              const currentIndex = slideshow.current || 0;
              console.log('🎯 Drag ended at index:', currentIndex);
              updateProgressBar(cardGallery, currentIndex, finalSlideCount, false);
            }, 50);
          }
        }
      });
    });

    observer.observe(slideshow, {
      attributes: true,
      attributeFilter: ['dragging', 'transitioning']
    });

    // Also listen for scroll events for smooth updates during drag
    const scroller = slideshow.querySelector('[ref="scroller"]');
    if (scroller) {
      let scrollTimeout;
      let lastScrollTime = 0;
      
      scroller.addEventListener('scroll', function() {
        const now = Date.now();
        
        // Only update during drag or if enough time has passed
        if (isDragging || now - lastScrollTime > 50) {
          clearTimeout(scrollTimeout);
          clearTimeout(dragUpdateTimeout);
          
          dragUpdateTimeout = setTimeout(function() {
            const currentIndex = slideshow.current || 0;
            
            // Only update if index actually changed
            if (currentIndex !== lastKnownIndex) {
              console.log('📜 Scroll update: Index changed from', lastKnownIndex, 'to', currentIndex);
              lastKnownIndex = currentIndex;
              updateProgressBar(cardGallery, currentIndex, finalSlideCount, false);
            }
            
            lastScrollTime = now;
          }, 10);
        }
      }, { passive: true });
    }
  }

  // Initialize all card galleries on page load
  function initializeAllGalleries() {
    console.log('🚀 Initializing all card galleries...');
    const cardGalleries = document.querySelectorAll('.card-gallery');
    console.log('📦 Found', cardGalleries.length, 'card galleries');
    cardGalleries.forEach(initializeCardGallery);
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAllGalleries);
  } else {
    initializeAllGalleries();
  }

  // Re-initialize when new content is loaded (for AJAX/infinite scroll)
  if (typeof MutationObserver !== 'undefined') {
    const contentObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            if (node.classList && node.classList.contains('card-gallery')) {
              console.log('➕ New card-gallery detected, initializing...');
              initializeCardGallery(node);
            } else {
              const galleries = node.querySelectorAll && node.querySelectorAll('.card-gallery');
              if (galleries && galleries.length > 0) {
                console.log('➕', galleries.length, 'new galleries detected');
                galleries.forEach(initializeCardGallery);
              }
            }
          }
        });
      });
    });

    contentObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();
